export default __webpack_public_path__ + "static/media/alert-icon.7f1cd921.svg";